import * as z from 'zod';

export const resetPasswordFormSchema = z.object({
  email: z.string().trim().email(),
});
